// extracted by mini-css-extract-plugin
export default {"banner":"Login_banner__SYWpj","overlay":"Login_overlay__k-yR-","appleLoginBtn":"Login_appleLoginBtn__UO-T9"};